// อ่าน claim ในตัว token ที่ IAM ออกให้
//
// **อ่านเพื่อแสดงผลเท่านั้น ไม่ใช่เพื่อตัดสินสิทธิ์** — ที่นี่ไม่ verify ลายเซ็น
// เพราะฝั่ง browser ไม่มี secret จะ verify ด้วยอยู่แล้ว การกันสิทธิ์จริงอยู่ที่ server
// ซึ่งถาม IAM ว่า token ใบนี้เป็นของใคร (ดู server/services/identity.service.ts)
export type Claims = Record<string, unknown>;

export const str = (v: unknown): string | undefined => (typeof v === "string" && v ? v : undefined);

export function decodeClaims(token: string): Claims | null {
  try {
    const payload = token.split(".")[1];
    if (!payload) return null;
    // JWT ใช้ base64url และตัด "=" ท้ายออก — atob ต้องได้ความยาวหาร 4 ลงตัว
    // ไม่เติมกลับ token บางตัวจะ decode ไม่ผ่านแบบสุ่ม ๆ ตามความยาว payload
    const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const json = atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4));
    // token มีชื่อไทย/อักขระ UTF-8 ได้ — atob คืน byte string ต้องถอดอีกชั้น
    const text = decodeURIComponent(
      json
        .split("")
        .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
        .join(""),
    );
    return JSON.parse(text) as Claims;
  } catch {
    return null;
  }
}

const MS_ROLE = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

/** role อาจเป็น string เดี่ยว, array, หรือชื่อแบบ MS-namespaced — รับทุกแบบแล้วตัดซ้ำ */
export function rolesFromClaims(claims: Claims): string[] {
  const raw = [claims.role, claims[MS_ROLE], claims.roles].flatMap((v) =>
    Array.isArray(v) ? v : v == null ? [] : [v],
  );
  return [...new Set(raw.filter((x): x is string => typeof x === "string" && !!x))];
}
